import {Component} from '@angular/core';

@Component({
  selector: 'app-outcome-icon',
  templateUrl: './outcome-icon.component.html',
  standalone: false,
})
export class OutcomeIconComponent {}
